module.exports = __webpack_public_path__ + "img/77.f44269f9.jpg";